<ion-content class="ion-padding">
    <ng-container>
        <!-- <app-header [title]="'Cancel Employee Work Order'"></app-header> -->
        <div style="max-width: 600px; margin: 40px auto; text-align: center;">
            <h2>Cancel work order created successfully</h2>
            <p>Work Order Number: <strong>#{{ workOrderNumber }}</strong></p>
            <p>
                <a href="javascript:void(0)" (click)="goToMainScreen()">Click here to redirect on main screen</a>
            </p>
        </div>
    </ng-container>

</ion-content>